var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg11B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1 0 0 1 0 -987.362121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3336"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.66,
    fill: "none",
    stroke: "#000000",
    d: "M0.7 1019.86 C0.7 1002.53 14.96 988.46 32.51 988.46 C50.05 988.46 64.31 1002.53 64.31 1019.86 C64.31 1037.18 50.05 1051.25 32.51 1051.25 C14.96 1051.25 0.7 1037.18 0.7 1019.86 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3338"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.17,
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M15.44 1018.95 C15.44 1010.22 22.93 1003.13 32.15 1003.13 C41.38 1003.13 48.87 1010.22 48.87 1018.95 C48.87 1027.69 41.38 1034.78 32.15 1034.78 C22.93 1034.78 15.44 1027.69 15.44 1018.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tspan3344",
    transform: "matrix(1.015035 0 0 0.985187 15.574184 1006.024169)"
  }, /*#__PURE__*/React.createElement("text", {
    kerning: 0,
    fontFamily: ".AppleSystemUIFont",
    fontWeight: 700,
    fontSize: 22.14
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.41
  }, "11"))), /*#__PURE__*/React.createElement("g", {
    id: "a4153",
    transform: "matrix(0.660896 0 0 0.654758 -0.849909 987.252441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3349"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.01,
    fill: "#0000ff",
    stroke: "#000000",
    d: "M15.88 16.46 L85.3 16.46"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path3351"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.66,
    fill: "none",
    stroke: "#000000",
    d: "M7.96 1039.75 L57.21 1039.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4158"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "M6.97 1038.32 C3.95 1034.26 1.93 1029.39 1.15 1024.3 C0.82 1022.17 0.82 1017.46 1.14 1015.42 C2.14 1009.18 4.65 1003.82 8.75 999.2 L9.49 998.37 L32.58 998.43 L55.67 998.5 L56.71 999.72 C59.49 1002.96 61.76 1007.17 62.97 1011.31 C64.84 1017.71 64.48 1025.04 62 1031.26 C61.1 1033.51 59.37 1036.58 58.02 1038.33 L57.41 1039.12 L39.78 1039.19 C30.09 1039.23 18.92 1039.29 14.97 1039.33 L7.77 1039.4 L6.97 1038.32 Z M34.79 1034.71 C36.65 1034.43 38.19 1033.94 39.91 1033.1 C41.74 1032.2 42.89 1031.38 44.33 1029.96 C47.37 1026.95 48.96 1023.19 48.96 1018.97 C48.97 1014.84 47.5 1011.22 44.61 1008.24 C40.99 1004.5 36.04 1002.66 30.71 1003.07 C29.16 1003.19 27.06 1003.66 25.72 1004.18 C21.21 1005.95 17.57 1009.72 16.08 1014.15 C15.05 1017.21 15.11 1021.08 16.22 1024.14 C17.77 1028.44 21.29 1031.97 25.75 1033.72 C26.8 1034.14 28.5 1034.58 29.68 1034.75 C30.92 1034.93 33.46 1034.91 34.79 1034.71 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3384",
    transform: "matrix(1 0 0 1 0 987.362121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M11.86 9.23 C15.78 5.69 21.73 2.91 27.49 1.95 C30.4 1.47 36.28 1.58 38.95 2.17 C44.2 3.35 49.75 6.1 53.07 9.19 L54.26 10.3 L32.47 10.3 L10.68 10.3 L11.86 9.23 L11.86 9.23 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3386",
    transform: "matrix(1 0 0 1 0 987.362121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M29.88 63.29 C22.63 62.71 16.04 59.76 10.92 54.79 L8.8 52.73 L28.82 52.73 C39.83 52.72 50.53 52.65 52.59 52.56 L56.35 52.41 L55.8 53.17 C55.04 54.24 52.02 56.79 49.72 58.3 C43.92 62.11 37 63.85 29.88 63.29 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11B);
export default __webpack_public_path__ + "static/media/11B.2aed50f71a99f36d36cdce228b577bf5.svg";
export { ForwardRef as ReactComponent };